import React, { ReactElement, useMemo } from "react";
import { ResizableBox } from "react-resizable";
import Styles from "./Resizable.module.scss";

interface ResizableProps {
    children: ReactElement;
    axis?: "x" | "y";
    direction: "e" | "w" | "n" | "s";
    minSize?: number;
    maxSize?: number;
    defaultSize?: number;
    className?: string;
}

export default function Resizable(props: ResizableProps): ReactElement {
    const min = props.minSize ?? 300;
    const max = props.maxSize ?? 500;
    const defaultSize = props.defaultSize ?? 400;

    const handler = useMemo(() => (
        <div
            className={`${Styles["react-resizable-handle"]} ${Styles[`react-resizable-handle-${props.direction}`]}`}
        />
    ), [props.direction]);

    return (
        <ResizableBox
            className={`${props.className} ${Styles["react-resizable"]} ${Styles[`react-resizable-${props.axis}`]}`}
            width={props.axis === "x" ? defaultSize : 0}
            height={props.axis === "y" ? defaultSize : 0}
            minConstraints={[props.axis === "x" ? min : 0, props.axis === "y" ? min as number : 0]}
            maxConstraints={[props.axis === "x" ? max : 0, props.axis === "y" ? max as number : 0]}
            resizeHandles={[props.direction]}
            handle={() => handler}
            axis={props.axis}
        >
            {props.children}
        </ResizableBox>
    );
}

Resizable.defaultProps = {
    axis: "x",
    defaultSize: 400,
    minSize: 300,
    maxSize: 500,
    className: "",
};
